import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const OPEN_RETURN_PREVIEW_ID_KEY = "openReturnPreviewId";
export const OPEN_RETURN_PREVIEW_ITEM_KEY = "openReturnPreviewItem";

export function useOpenReturnPreviewFromLocation(loadPreview, openPreview) {
  const location = useLocation();
  const navigate = useNavigate();
  const startedRef = useRef(false);

  useEffect(() => {
    const previewId = location.state?.[OPEN_RETURN_PREVIEW_ID_KEY];
    if (previewId == null || startedRef.current) {
      return;
    }

    startedRef.current = true;
    const calendarItem = location.state?.[OPEN_RETURN_PREVIEW_ITEM_KEY] || {};
    const nextState = { ...(location.state || {}) };
    delete nextState[OPEN_RETURN_PREVIEW_ID_KEY];
    delete nextState[OPEN_RETURN_PREVIEW_ITEM_KEY];
    navigate(`${location.pathname}${location.search}`, {
      replace: true,
      state: Object.keys(nextState).length > 0 ? nextState : {},
    });

    Promise.resolve(loadPreview(previewId))
      .then((data) =>
        openPreview({
          id: previewId,
          ...calendarItem,
          ...(data && typeof data === "object" ? data : {}),
        })
      )
      .catch(() => {});
  }, [loadPreview, location, navigate, openPreview]);
}
